export enum StepCondition {
  Disabled = 'disabled',
  Active = 'active',
  Completed = 'completed',
  Progress = 'progress'
}
